import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateSubAgentModalComponent } from 'src/app/non-admin/pages/sub-agent-management/create-sub-agent-modal/create-sub-agent-modal.component';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalService } from 'src/app/services/modal-service/modal.service';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  showErrorMessages: boolean = false;
  isSubmitting: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ForgotPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialog: MatDialog,
    private apiService: ApiService,
    private modalService: ModalService,
    private formBuilder: FormBuilder,
  ) { }

  form: FormGroup;

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      email: [this.dialogData.email, [Validators.required, Validators.email]]
    })

    if (this.dialogData.email) {
      this.form.markAsDirty()
    }
  }

  openConfirmModal() {
    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'operation-modal', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you want to change your account password?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.sendPasswordResetLink()
        },
        onCancel: () => { },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  sendPasswordResetLink() {
    this.isSubmitting = true;
    this.apiService.post('/auth/user/initiate/forget-password', { email: this.form?.value?.email }).subscribe((res: any) => {
      this.modalService.openSuccessModal('Password reset link sent successfully. Pls check your email: ' + this.form?.value?.email).afterClosed().subscribe(() => {
        this.dialogRef
      })
      this.isSubmitting = false;
    }, () => {
      this.isSubmitting = false;

    });

  }


  closeModal(): void {
    this.dialogRef.close();
  }

}
